<!--
 * @Author: George
 * @Description: 个人信息表 - 高才申请人信息回显
-->
<template>
    <!-- 回显信息 -->
    <div ref="userDetail" class="details-module common-part">
        <!-- 主申请人信息 -->
        <el-row :gutter="15">
            <el-col :span="12" id="application_type">
                <span>申请类型：</span>
                <span>{{
                    CONFIG.APPLY_TYPE_REFLECT[currentItem.application_type] ||
                    "-"
                }}</span>
            </el-col>
            <el-col :span="12" id="has_approved_stay_hk">
                <span>是否已获准留港：</span>
                <span>{{ currentItem.has_approved_stay_hk === 1 ? '是' : currentItem.has_approved_stay_hk === 2 ? '否' : '-' }}</span>
            </el-col>
            <el-col :span="12" id="username">
                <span>主申姓名：</span>
                <span>{{ currentItem.username || "-" }}</span>
            </el-col>
            <el-col :span="12" id="used_name">
                <span>曾用名：</span>
                <span class="text-red">{{ currentItem.used_name || "-" }}</span>
            </el-col>
            <el-col :span="12">
                <span>婚前姓氏：</span>
                <span>{{ currentItem.surname || "-" }}</span>
            </el-col>
            <el-col :span="12" id="username_pinyin">
                <span>姓名拼音：</span>
                <span>{{
                    currentItem.username_pinyin.family_name +
                    " " +
                    currentItem.username_pinyin.given_name
                }}</span>
            </el-col>
            <el-col :span="12" id="user_sex">
                <span>性别：</span>
                <span>{{
                    CONFIG.SEX_TYPE_REFLECT[currentItem.sex] || "-"
                }}</span>
            </el-col>
            <el-col :span="12" id="user_birthday">
                <span>出生日期：</span>
                <span>{{ currentItem.birthday }}</span>
                <!-- （<span class="text-red">{{
                        `${dataList[0].age}岁`
                    }}</span
                    >） -->
            </el-col>
            <el-col :span="12" id="user_nationality">
                <span>国籍：</span>
                <span>{{ currentItem.nationality || "-" }}</span>
            </el-col>
            <el-col :span="12" id="birth_place_aboard">
                <span>出生城市：</span>
                <span>{{
                    currentItem.birth_place_aboard === 0
                        ? currentItem.birth_place.details
                        : currentItem.birth_place.foreign
                }}</span>
            </el-col>
            <el-col :span="12" id="is_eligibility_criteria">
                <span>是否符合申请资格：</span>
                <span>{{
                    currentItem.is_eligibility_criteria === 0
                        ? '否' : '是'
                }}</span>
            </el-col>
            <el-col :span="24" id="user_address">
                <span>现居住地址：</span>
                <span id="user_address_detail">{{ currentItem.address.country + '-' + (isInChinaMainland ? (currentItem.address.area.join('') + currentItem.address.details) : currentItem.address.foreign) }}</span>
            </el-col>
            <!-- <el-col :span="12" id="user_address" v-if="!inChina">
                <span>是否居住满一年及以上：</span>
                <span>{{ currentItem.is_live_oversea_year === 1 ? '是' : '否' }}</span>
            </el-col> -->
            <el-col :span="12" id="user_married">
                <span>婚姻状况：</span>
                <span>{{
                    CONFIG.MARRY_TYPE_REFLECT[currentItem.married] || "-"
                }}</span>
            </el-col>
            <el-col :span="12">
                <span>是否办理过香港身份证：</span>
                <span class="text-red">{{
                    CONFIG.HAS_HK_CARD_REFLECT[currentItem.has_hk_id.has] || "-"
                }}</span>
            </el-col>
            <el-col :span="12" id="user_hk_id_number">
                <span>香港身份证号码：</span>
                <span>{{
                    currentItem.has_hk_id.has === "Y"
                        ? currentItem.has_hk_id.info
                        : "-"
                }}</span>
            </el-col>
            <el-col :span="12" id="industry">
                <span>所在行业：</span>
                <span>{{
                    CONFIG.INDUSTRY_TYPE_REFLECT[currentItem.industry] || "-"
                }}</span>
            </el-col>
            <el-col
                :span="12"
                id="industry_other_desc"
                v-if="currentItem.industry === 28"
            >
                <span>其他行业：</span>
                <span>{{ currentItem.industry_other_desc || "-" }}</span>
            </el-col>
            <el-col :span="12" id="certificates.passport.type">
                <span>证件类型：</span>
                <span>{{
                    CONFIG.CERTIFICATE_TYPE_REFLECT[
                        currentItem.certificates.passport.type
                    ] || "-"
                }}</span>
            </el-col>
            <el-col :span="12" id="certificates.passport.number">
                <span>证件号码：</span>
                <span>{{ currentItem.certificates.passport.number }}</span>
            </el-col>
            <el-col :span="12" id="certificates.passport.issue_at">
                <span>签发地：</span>
                <span>{{ currentItem.certificates.passport.issue_at }}</span>
            </el-col>
            <el-col :span="12" id="certificates.passport.issue_date_start_at">
                <span>签发日期：</span>
                <span>{{
                    currentItem.certificates.passport.issue_date_start_at
                }}</span>
            </el-col>
            <el-col :span="12" id="certificates.passport.issue_date_end_at">
                <span>届满日期：</span>
                <span>{{
                    currentItem.certificates.passport.issue_date_end_at
                }}</span>
            </el-col>
            <template v-if="currentItem.application_type === 2 || currentItem.application_type === 3">
                <el-col :span="12" id="undergraduate_end_time">
                    <span>本科毕业年份：</span>
                    <span>{{ currentItem.undergraduate_end_time || "-" }}</span>
                </el-col>
                <el-col :span="12" id="undergraduate_end_time">
                    <span>本科毕业月份：</span>
                    <span>{{ currentItem.undergraduate_graduation_month || "-" }}</span>
                </el-col>
                <el-col :span="12" id="years_of_work">
                    <span>工作年限：</span>
                    <span>{{
                        CONFIG.WORK_YEAR_TYPE_REFLECT[
                            currentItem.years_of_work
                        ] || "-"
                    }}</span>
                </el-col>
                <el-col :span="12" id="college">
                    <span>本科就读院校名称：</span>
                    <span>{{ currentItem.college_text || "-" }}</span>
                </el-col>
                <el-col :span="12" id="college">
                    <span>就读地点：</span>
                    <span>
                        {{
                            currentItem.school_address.country.indexOf('中国') !== -1
                                ? currentItem.school_address.country + currentItem.school_address.area.join("")
                                : currentItem.school_address.country + currentItem.school_address.foreign
                        }}
                    </span>
                </el-col>
                <el-col :span="12" id="majors">
                    <span>主修科目：</span>
                    <span>{{ currentItem.majors || "-" }}</span>
                </el-col>
                <el-col v-if="currentItem.majors == '其它 （请注明）'" :span="12" id="years_of_work">
                    <span>其他：</span>
                    <span>{{ currentItem.majors_other || "-" }}</span>
                </el-col>
                <el-col :span="12" id="years_of_work">
                    <span>你是否获上述大学颁授的学士学位?</span>
                    <span>{{ currentItem.has_degree === 1 ? '是' : currentItem.has_degree === 2 ? '否' : "-" }}</span>
                </el-col>
            </template>

            <template v-if="isApplicantShow">
                <el-col :span="24" id="have_permanent_residency">
                    <span>申请人是否拥有现时定居国家/地区的永久居留身份：</span>
                    <span>{{ currentItem.have_permanent_residency == 1 ? '是' : '否' }}</span>
                </el-col>
                <!-- <el-col :span="24" id="is_currently_overseas">
                    <span>申请人现正居在海外：</span>
                    <span>{{ currentItem.is_currently_overseas == 1 ? '是' : '否' }}</span>
                </el-col> -->
                <el-col :span="24" id="residence_time" v-if="currentItem.have_permanent_residency != 1">
                    <span>在定居国家/地区居留时间：</span>
                    <span>{{ currentItem.residence_time || "-" }}</span>
                </el-col>
            </template>

            <el-col :span="24" id="declaration_first" class="declaration">
                <span>相关说明1：</span>
                <div>
                    <p v-if="currentItem.declaration_first === 0">
                        本人未曾被拒绝签发签证或入境香港，同时也没有被遣返、遣送或要求离开香港的情况
                    </p>
                    <div v-if="currentItem.declaration_first === 1">
                        <p>
                            本人曾经遭到过拒签或被拒绝入境香港的情况，具体日期和详细情况如下：
                        </p>
                        <p>{{ currentItem.declaration_first_desc }}</p>
                    </div>
                </div>
            </el-col>
            <el-col :span="24" id="declaration_second" class="declaration">
                <span>相关说明2：</span>
                <div>
                    <p v-if="currentItem.declaration_second === 0">
                        本人从未因任何罪行或违法行为在香港或其他地方被定罪
                    </p>
                    <div v-if="currentItem.declaration_second === 1">
                        <p>
                            本人曾因任何罪行或违法行为在香港或其他地方被定罪。有关日期和详细情况如下：
                        </p>
                        <p>{{ currentItem.declaration_second_desc }}</p>
                    </div>
                </div>
            </el-col>

            <el-col :span="12" v-if="showPlan">
                <span>身份计划：</span>
                <span>{{ formatValue(currentItem,'identity_plan') }}</span>
            </el-col>

            <template v-if="showPlan && (currentItem.identity_plan === 1 || currentItem.identity_plan === 2)">
                <el-col :span="12">
                    <span>收入分类：</span>
                    <span>{{ formatValue(currentItem,'income_category') }}</span>
                </el-col>

                <el-col :span="12">
                    <span>收入细化类别：</span>
                    <span>{{ formatValue(currentItem,'income_detail_type') }}</span>
                </el-col>

                <el-col :span="12">
                    <span>赴港同意书提供单位：</span>
                    <span>{{ formatValue(currentItem,'approval_unit') }}</span>
                </el-col>

                <el-col :span="12">
                    <span>预计递交时间：</span>
                    <span>{{ currentItem.ready_to_submit_at }}</span>
                </el-col>

                <el-col :span="12">
                    <span>是否孵化：</span>
                    <span>{{ formatValue(currentItem,'is_incubated') }}</span>
                </el-col>

                <el-col :span="12" v-if="currentItem.is_incubated === 1">
                    <span>孵化卡点：</span>
                    <span>{{ formatValue(currentItem,'incubation_bottleneck') }}</span>
                </el-col>

                <el-col :span="12" v-if="currentItem.identity_plan === 1 && currentItem.is_incubated === 1">
                    <span>孵化项目：</span>
                    <span>{{ formatValue(currentItem,'incubation_project') }}</span>
                </el-col>

                <el-col :span="12" v-if="currentItem.identity_plan === 2 && currentItem.is_incubated === 1">
                    <span>孵化情况：</span>
                    <span>{{ formatValue(currentItem,'incubation_status') }}</span>
                </el-col>

                <el-col :span="12" v-if="currentItem.identity_plan === 1 && Array.isArray(currentItem.incubation_project) && currentItem.incubation_project.includes(1)">
                    <span>考试类别：</span>
                    <span>{{ formatValue(currentItem,'exam_types') }}</span>
                </el-col>

                <el-col :span="12" v-if="currentItem.identity_plan === 1 && Array.isArray(currentItem.incubation_project) && currentItem.incubation_project.includes(1)">
                    <span>考试时间：</span>
                    <span>{{ currentItem.exam_date }}</span>
                </el-col>

                <el-col :span="12" v-if="currentItem.identity_plan === 1 && Array.isArray(currentItem.incubation_project) && currentItem.incubation_project.includes(2)">
                    <span>预计学位授予时间：</span>
                    <span>{{ currentItem.expected_degree_award_date }}</span>
                </el-col>

                <el-col :span="12" v-if="currentItem.identity_plan === 1 && Array.isArray(currentItem.incubation_project) && currentItem.incubation_project.includes(3)">
                    <span>预计达标时间：</span>
                    <span>{{ currentItem.expected_achievement_date }}</span>
                </el-col>
            </template>
        </el-row>
    </div>
</template>

<script>
import CONFIG from "../../config";
//import { config } from '../../../Gifted/User/C/config'
export default {
    props: {
        currentItem: {
            type: Object,
            default() {
                return {};
            },
        },
        selectOptions: {
            type: Object,
            default: () => ({
                identity_plan: [],
                income_category: [],
                income_detail_type: [],
                approval_unit: [],
                exam_types: [],
                is_incubated:[
                    { label: '是', value: 1 },
                    { label: '否', value: 2 },
                ],
                incubation_status: [],
                incubation_project: [],
                incubation_bottleneck: [],
            }),
        },
    },
    computed: {
        inChina() {
            console.log(this.currentItem);
            return !!(this.currentItem.address.country && this.currentItem.address.country.includes('中国'))
        },
        isInChinaMainland() {
            return this.currentItem.address.country && this.currentItem.address.country.includes('中国-China')
        },
        isApplicantShow() {
            const { nationality, address: { country, area } } = this.currentItem
            const specialAreas = ['香港特别行政区', '澳门特别行政区', '台湾']
            return nationality === '中国-China' && (country !== '中国-China' || (area.length > 0 && specialAreas.includes(area[0])))
        },
        showPlan(){
            return this.$route.query.system_name && this.$route.query.system_name === 'CRM-server'
        },
    },
    data() {
        return {
            CONFIG,
        };
    },
    methods: {
        formatValue(obj, key) {
            const value = obj[key]
            if (Array.isArray(value)) {
                return this.selectOptions[key].filter(item => value.includes(item.value)).map(item => item.label).join(';') || '-'
            } else {
                return this.selectOptions[key].find(item => item.value === value)?.label || '-'
            }
        }
    }
};
</script>

<style lang="less" scoped>
.declaration {
    align-items: flex-start !important;
}
</style>
